import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { RenderIf } from '../../utils/fns'

import '../../globals/scss/components/accordion.scss'

export const Accordion = ({ title, icon, children, className, ...props }) => {
  const [accordionOpen, setAccordionOpen] = useState(true)

  return (
    <div className={`accordion ${accordionOpen ? '-open' : ''} ${className ?? ''}`} {...props}>
      <h3 className="accordion__header" onClick={() => setAccordionOpen(!accordionOpen)}>
        {RenderIf(
          icon,
          <span className="accordion__headerImg">
            <img className="ui avatar image" src={icon} alt="accordion's icon" />
          </span>,
        )}
        <span className="accordion__headerTitle">{title}</span>
        <span className="material-icons accordion__headerCaret">keyboard_arrow_right</span>
      </h3>

      <div className="accordion__body">{children}</div>
    </div>
  )
}

Accordion.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  icon: PropTypes.string,
  className: PropTypes.string,
}
